module.exports = __webpack_public_path__ + "img/snackPhone.780d924.png";